/** Tracks in-flight axiosClient requests for the global overlay. */

let pendingCount = 0;
const listeners = new Set();

function notify() {
  listeners.forEach((fn) => {
    try {
      fn(pendingCount);
    } catch {
      // ignore listener errors
    }
  });
}

export function subscribeGlobalLoading(listener) {
  listeners.add(listener);
  listener(pendingCount);
  return () => listeners.delete(listener);
}

export function getGlobalLoadingCount() {
  return pendingCount;
}

export function trackRequestStart(config) {
  if (!config || config.skipGlobalLoader === true) return;
  config._globalLoadingTracked = true;
  pendingCount += 1;
  notify();
}

export function trackRequestEnd(config) {
  if (!config?._globalLoadingTracked) return;
  config._globalLoadingTracked = false;
  pendingCount = Math.max(0, pendingCount - 1);
  notify();
}

/** Escape hatch if a bug leaves the overlay stuck (e.g. after HMR). */
export function resetGlobalLoading() {
  pendingCount = 0;
  notify();
}
